<frontend-pull-refresh></frontend-pull-refresh>

<section class="background-background px-3 pb-3">
  <h1 class="pt-3">Resources Settings</h1>
  <form *ngIf="resourcesForm" role="form" [formGroup]="resourcesForm" novalidate>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="resources-enabled" class="col-form-label lead">Enable Resources</label>
        <p>Enable the Resources feature.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="resources-enabled"
                   name="servicesEnabled"
                   formControlName="enabled">Enable
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="resourcesForm.get('enabled').value">
      <div class="row form-group" >
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="resources-label" class="lead col-form-label">Resource label</label>
          <p>What is a resource called? E.g., Table, Room, Employee, Lane, etc.</p>
        </div>
        <div class="col-sm-5 col-md-5 col-lg-3 mt-2">
          <input type="text"
                 class="form-control"
                 id="resources-label"
                 formControlName="label"
                 name="servicesSettingsLabel"
                 [class.is-invalid]="resourcesForm.get('label').invalid && resourcesForm.get('label').touched" />
          <control-messages [control]="resourcesForm.get('label')"></control-messages>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="resources-show-on-pages" class="col-form-label lead">
            Display on Waitlist <br/> &amp; {{ who.location.displayOptions.labels.reservation_plural | titlecase }} pages
          </label>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     id="resources-show-on-pages"
                     name="showOnPages"
                     formControlName="showOnPages">Enable
            </label>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label class="lead col-form-label">Sort by</label>
          <p>Sort your resources.</p>
        </div>
        <div class="col-sm-5 mt-2">
          <div class="form-group">
            <frontend-dropdown-plain
              elementId="resources-sort"
              formControlName="sort"
              [items]="sort"
            ></frontend-dropdown-plain>
          </div>
        </div>
      </div>
      <div class="row form-group" *ngIf="who.location.serviceSettings.enabled">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label class="lead col-form-label">Assign services</label>
          <p>Select services and add it to all resources.</p>
        </div>
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 mt-2">
          <frontend-dropdown
            class="w-100"
            [items]="services"
            bindLabel="name"
            bindValue="_id"
            [multiple]="true"
            formControlName="services"
            placeholder="Select services"
            [clearable]="true"
          ></frontend-dropdown>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-3 offset-sm-3 offset-md-2">
        <button class="btn btn-info"
                [disabled]="resourcesForm.pristine || !resourcesForm.valid"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Save Resources Settings"
                (click)="saveResourcesSettings()">Save
        </button>
      </div>
    </div>

    <div *ngIf="this.resourcesForm.get('enabled').value">
      <h2 class="pt-3">Resources</h2>
      <tr-resources-list
        #resourcesList
        [resourceSettings]="resourceSettings"
        [serviceSettings]="serviceSettings"
        [services]="services"
        [resources]="resources"
        [showCategories]="showCategories"
        [isReorder]="isReorder"
        [resourcesCategories]="resourcesCategories"
        [reservationsLabel]="who.location.displayOptions.labels.reservation_plural"
        (addEditResourceCalled)="addEditResource($event)"
        (availabilityToggled)="toggleEnabled($event)"
        (resourceRemoved)="deleteResource($event)"
        (updatedBulk)="updateBulk($event)"
        (resourceSettingsUpdated)="updateResourceSettings($event)"
      ></tr-resources-list>
      <div class="add-new">
      <span class="add-new-blocker" slot="fixed">
        <button type="button"
                class="btn btn-accent btn-circle"
                (click)="addEditResource()"
                id="addEditParty-button">
            <tr-icon [icon]="icon.plus" [size]="size.extraLarge" [color]="color.white"></tr-icon>
        </button>
      </span>
      </div>
    </div>
  </form>

</section>
